module.exports = __webpack_public_path__ + "img/athena_statue.c29fecc6.jpg";